const backend_url="https://emerald-jellyfish-belt.cyclic.app"
export default(backend_url)